import Reflux from 'reflux';
import { Map } from 'immutable';
import VersionNumberActions from 'flux/actions/VersionNumberActions';
import BaseMixin from 'flux/stores/BaseMixin';

export default Reflux.createStore({
  mixins: [BaseMixin],

  listenables: [VersionNumberActions],

  init() {
    this.setState(Map({}));
    this.onShow();
  },

  onHide() {
    this.setInStateAndTrigger('display', false);
  },

  onShow() {
    this.setInStateAndTrigger('display', true);
  },
});
